interface Props {
  /** DOM id — stable hook for tests. */
  id?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  children: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
}

export default function Button({ id, type = 'button', onClick, children, loading, disabled, fullWidth, variant = 'primary' }: Props) {
  const base = 'flex items-center justify-center gap-2 px-4 py-2.5 rounded-hbs-md text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary:   'bg-hbs-primary hover:bg-hbs-primary-hover text-white',
    secondary: 'bg-hbs-surface-alt hover:bg-hbs-surface-alt text-hbs-text',
    danger:    'bg-red-500/20 hover:bg-red-500/30 text-red-400',
  };

  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''}`}
    >
      {loading && (
        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {children}
    </button>
  );
}
